import * as $ from "jquery";
import moment from "moment";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Location } from "vue-router/types/router";
import { ContratElementVariableDto } from "../../dto/GenApi.iNotPaie.Dto/ContratElementVariableDto";
import { DemandeCalculPaieDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeCalculPaieDto";
import { ElementVariableDto } from "../../dto/GenApi.iNotPaie.Dto/ElementVariableDto";
import { EtatSaisie } from "../../dto/GenApi.iNotPaie.Dto/EtatSaisie";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { AjoutPeriodeVariableParam } from "../../shared/interfaces/ajoutPeriodeVariable.interface";
import { Debounce } from "../../shared/services/debounce.service";
import { NavigationData } from "../../shared/services/navigation.service";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ObjectParsingInstance } from "../Controls/ObjectParsing";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalAjoutPeriodeVariable from "./modalAjoutPeriodeVariable/modalAjoutPeriodeVariable";
import ModalCalculBulletin from "./modalCalculBulletin/modalCalculBulletin";
import ModalImportCsv from "./modalImportCsv/modalImportCsv";
import ModalMessage from "./modalMessage/modalMessage";
import ModalParamVariablesPst from "./modalParamVariablesPst/modalParamVariablesPst";
import ModalRecapAllVariables from "./modalRecapAllVariables/modalRecapAllVariables";
import ModalRecapVariables from "./modalRecapVariables/modalRecapVariables";

interface familleModel {
    libelle: string;
    code: string;
    sousFamilles: ParametreDto[];
}

@Component({
    components: {
        ModalMessage: require("./modalMessage/modalMessage.vue.html"),
        ModalRecapVariables: require("./modalRecapVariables/modalRecapVariables.vue.html"),
        ModalRecapAllVariables: require("./modalRecapAllVariables/modalRecapAllVariables.vue.html"),
        ModalCalculBulletin: require("./modalCalculBulletin/modalCalculBulletin.vue.html"),
        ModalAjoutPeriodeVariable: require("./modalAjoutPeriodeVariable/modalAjoutPeriodeVariable.vue.html"),
        ModalParamVariablesPst: require("./modalParamVariablesPst/modalParamVariablesPst.vue.html"),
        ModalImportCsv: require("./modalImportCsv/modalImportCsv.vue.html")
    }
})
export default class SaisieDesVariables extends VueBase {
    contrats: ContratElementVariableDto[] = [];
    contratsBase: ContratElementVariableDto[] = [];
    contratsFiltred: ContratElementVariableDto[] = [];
    filterName = "";
    filterVariable = "";
    curentOrderColumn = "FullName";
    orderingDesc = true;
    colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
    dataReady = false;
    roles: string[] = [];
    modeSalarieHaut = false;
    isUtilisateurPst = false;
    HasMessageInformation = false;
    familles: familleModel[] = [{ code: "", libelle: "Toutes les catégories", sousFamilles: [{ Id: 0, Code: "Tous", Libelle: "Tous les scénarios", Modifiable: false, EstVisiblePst: true, EstVisibleEtudePst: true, EstArchive: false }] },
    { code: "0/", libelle: "Scénarios courants", sousFamilles: [] },
    { code: "1/", libelle: "Scénarios exceptionnels", sousFamilles: [] },
    { code: "2/", libelle: "Scénarios de départ", sousFamilles: [] }];

    etatSaisie?: EtatSaisie = undefined;
    displayMessageContrat = true;
    displaySocietePst = false;
    allowImportCsv = false;
    canEditVariables = true;
    displayButton = false;
    sousFamille: ParametreDto[] = [];
    selectedCodeFamille = "";
    selectedCodeSousFamille?: string = "";
    listeRubrique: ParametreDto[] = [];
    listeRubriqueFiltred: ParametreDto[] = [];

    modalCalculBulletin?: ModalCalculBulletin = undefined;
    modalRecapVariables?: ModalRecapVariables = undefined;
    modalRecapAllVariables?: ModalRecapAllVariables = undefined;
    modalAjoutPeriodeVariable?: ModalAjoutPeriodeVariable = undefined;
    modalParamVariablesPst?: ModalParamVariablesPst = undefined;
    modalMessage?: ModalMessage = undefined;
    modalImportCsv?: ModalImportCsv = undefined;
    allSelected = false;

    leftPosition = 0;
    private variablesLoaded = false;

    @Watch("selectedCodeFamille")
    onSelectedCodeFamilleChanged(value: string, oldValue: string) {
        if (value == oldValue) {
            return;
        }
        const famille = this.familles.filter(f => f.code == this.selectedCodeFamille);
        if (famille.length == 1) {
            this.sousFamille = famille[0].sousFamilles;
        }
        if (this.sousFamille.length > 0 && this.sousFamille[0].Code != undefined) {
            this.selectedCodeSousFamille = this.sousFamille[0].Code;
        }
    }

    @Watch("selectedCodeSousFamille")
    onSelectedCodeSousFamilleChanged(value?: string, oldValue?: string) {
        if (ParametresInstance.utilisateurCourant == undefined) {
            return;
        }

        this.listeRubrique = [];
        if (!this.isUtilisateurPst && value != "Tous") {
            ServicesFactoryInstance.VariablesService.getVariables(this.selectedCodeSousFamille, data => {
                this.listeRubrique = data;
                this.variablesLoaded = true;
                this.doFilterVariable();
            });
        } else {
            ServicesFactoryInstance.VariablesService.getVariables("", data => {
                this.listeRubrique = data;
                this.variablesLoaded = true;
                this.doFilterVariable();
            });
        }
    }

    /**
     * Changement structurel du tableau :
     * - dataReady passe à true → le tableau passe de v-show=false à visible,
     *   les dimensions DOM sont désormais mesurables.
     * - modeSalarieHaut change → le DOM est intégralement recréé (v-if/v-else),
     *   il faut se rattacher au nouvel élément <table>.
     *
     * Dans les deux cas on remet les plages à zéro et on ré-initialise.
     */
    @Watch("dataReady")
    @Watch("modeSalarieHaut")
    private onVirtReInit(): void {
        if (!this.dataReady) {
            return;
        }

        this.reinitialiserPlagesVisibles();
        this.$nextTick(() => this.initialiserVirtualisation());
    }

    /**
     * Les données source changent :
     * - listeRubriqueFiltred change → changement de scénario ou filtre variable.
     * - contratsFiltred change → filtre salarié ou rechargement des données.
     *
     * On remet les plages et le scroll à zéro puis on recalcule.
     */
    @Watch("listeRubriqueFiltred")
    @Watch("contratsFiltred")
    private onVirtDonneesChanged(): void {
        this.reinitialiserPlagesVisibles();
        this.$nextTick(() => {
            const table = this.getTableElement();
            if (table) {
                table.scrollTop = 0;
                table.scrollLeft = 0;
            }

            this.recalculerPlageVisible();
        });
    }

    changeModeSalarieHaut(val: boolean) {
        if (!this.dataReady || this.modeSalarieHaut == val) {
            return;
        }

        this.modeSalarieHaut = val;
        this.saveProfilUtilisateur();
    }

    checkIsModified(location: Location): boolean {
        return super.checkIsModified(location);
    }

    /**
     * Evite les recalculs inutiles du filtre lors de la saisie de texte dans le champ de recherche des variables.
     * @param delay Le délai en millisecondes avant de recalculer le filtre.
     * @returns void
     */
    @Debounce(250)
    private doFilterVariableDebounced(): void {
        this.doFilterVariable();
    }

    doFilterVariable() {
        if (this.isUtilisateurPst) {
            this.listeRubriqueFiltred = ObjectParsingInstance.removeDuplicateByUniqueKey(this.listeRubrique.filter(d => d.EstVisibleEtudePst), "Id");
        } else {
            this.listeRubriqueFiltred = this.listeRubrique;
        }

        // TODO : Rajouter une recherche de variables
        if (this.filterVariable != "") {
            this.listeRubriqueFiltred = this.listeRubriqueFiltred.filter(v => (v.Code != undefined && v.Code.toLowerCase().indexOf(this.filterVariable.toLowerCase()) > -1) || (v.Libelle != undefined && v.Libelle.toLowerCase().indexOf(this.filterVariable.toLowerCase()) > -1));
        }
    }

    click_check(target) {
        const element: HTMLElement = document.getElementById(target) as HTMLElement;
        element.click();
    }

    openAddItemForSelected(idRubrique: number, codeRubrique: string, codeNature: string, codeVariable: string) {
        if (this.modalAjoutPeriodeVariable == undefined) {
            this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
        }

        this.modalAjoutPeriodeVariable.setElementVariable(true, idRubrique, undefined, codeRubrique, codeNature, codeVariable);
        $("#modalAjoutPeriodeVariable").modal("show");
    }

    messageAdded(param) {
        if (param.NumeroContrat == 0) {
            this.HasMessageInformation = true;

            return;
        }
        for (let i = 0; i < this.contratsFiltred.length; i++) {
            const c: ContratElementVariableDto = this.contratsFiltred[i];
            if (c.Id == param.IdContratFk && param.TypeMessage == "I") {
                c.HasMessageInformation = true;

                return;
            }
            if (c.Id == param.IdContratFk && param.TypeMessage == "E") {
                c.HasMessageContrat = true;

                return;
            }
        }
    }

    messageDeleted(param) {
        if (param.NumeroContrat == 0) {
            this.HasMessageInformation = false;

            return;
        }
        for (let i = 0; i < this.contratsFiltred.length; i++) {
            const c: ContratElementVariableDto = this.contratsFiltred[i];
            if (c.Id == param.IdContratFk && param.TypeMessage == "I") {
                c.HasMessageInformation = false;

                return;
            }
            if (c.Id == param.IdContratFk && param.TypeMessage == "E") {
                c.HasMessageContrat = false;

                return;
            }
        }
    }

    validateAjoutAll(param: AjoutPeriodeVariableParam): void {
        for (let i = 0; i < this.contratsFiltred.length; i++) {
            const c: any = this.contratsFiltred[i];
            if (c.selected) {
                const contrat = this.contratsFiltred[i];
                const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == param.codeRubrique && e.CodeNature == param.codeNature);

                if (variable.length > 0) {
                    variable[0].Montant = param.value;
                    variable[0].DateDebut = param.dateDebut;
                    variable[0].DateFin = param.dateFin;
                    variable[0].CodeVariable = param.codeVariable;
                } else {
                    contrat.ElementVariables.push({
                        Id: 0,
                        IdRubrique: param.idRubrique,
                        CodeRubrique: param.codeRubrique,
                        CodeNature: param.codeNature,
                        DateDebut: param.dateDebut,
                        DateFin: param.dateFin,
                        Montant: param.value,
                        CodeTypeElementVariable: "VARIA",
                        CodeVariable: param.codeVariable,
                        EstSoumise: true,
                        EstValidee: true
                    });
                }
                c.selected = false;
            }
        }
    }

    allSelectedChanged() {
        for (let i = 0; i < this.contratsFiltred.length; i++) {
            const c: any = this.contratsFiltred[i];
            c.selected = !this.isSaisieVariableDisabled(c) && this.allSelected;
        }
    }

    setDisplayOptions(): any {
        if (ParametresInstance.societeCourante == undefined) {
            this.displayMessageContrat = false;
            this.canEditVariables = false;

            return;
        }
        ServicesFactoryInstance.ExercicesService.getMessage("I", 0, data => {
            this.HasMessageInformation = data != null;
        });
        this.etatSaisie = ParametresInstance.societeCourante.EtatSaisie;
        this.displayMessageContrat = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);
        this.canEditVariables = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) || this.etatSaisie == EtatSaisie.SaisieEnCours;
        this.displaySocietePst = ParametresInstance.isPst;
        this.allowImportCsv = ParametresInstance.userIsAuthorized([RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.Payeur]);
    }

    ParamVariables() {
        if (this.modalParamVariablesPst == undefined) {
            this.modalParamVariablesPst = this.$refs.modalParamVariablesPst as ModalParamVariablesPst;
        }

        if (this.modalParamVariablesPst == undefined) {
            return;
        }
        this.modalParamVariablesPst.Init();
        $("#modalParamVariablesPst").modal("show");
    }

    checkEtatSaisie(etat: number): boolean {
        if (this.etatSaisie == etat) {
            return true;
        }

        return false;
    }

    saveProfilUtilisateur() {
        if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
            ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut = this.modeSalarieHaut;
            this.dataReady = false;
            ServicesFactoryInstance.UtilisateurService.updateProfil(ParametresInstance.utilisateurCourant.ProfilUtilisateur, () => {
                this.dataReady = true;
            }, () => {
                this.dataReady = true;
            });
        }
    }

    mounted() {
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, obj => {
            if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
                this.modeSalarieHaut = ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut;
            }
            // Si les variables n'ont pas été chargées (watcher a skip car utilisateur pas dispo), on les charge maintenant
            if (this.selectedCodeSousFamille && !this.variablesLoaded) {
                this.onSelectedCodeSousFamilleChanged(this.selectedCodeSousFamille, this.selectedCodeSousFamille);
            }
        });

        EventBus.$on(EventConstants.SOCIETE_CHANGED, obj => {
            this.annuler();
        });

        if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
            this.modeSalarieHaut = ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut;
        }

        this.getFamilles();
        this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
        EventBus.$on(EventConstants.IS_PST_CHANGED, this.setDisplayOptions);
        EventBus.$on(EventConstants.ETAT_SAISIE_CHANGED, this.setDisplayOptions);

        if (ParametresInstance.societeCourante != undefined) {
            this.etatSaisie = ParametresInstance.societeCourante.EtatSaisie;
        }

        this.fetchData();
        this.setUserRole();
        this.setDisplayOptions();
    }

    setUserRole() {
        this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);
    }

    getFamilles() {
        ServicesFactoryInstance.ParametresService.getTypeVariable(data => {
            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < this.familles.length; j++) {
                    const typeVariable = data[i];
                    const famille = this.familles[j];

                    const complement: string = typeVariable.Complement != undefined ? typeVariable.Complement : "";

                    if (complement.indexOf(famille.code) == 0) {
                        famille.sousFamilles.push(typeVariable);
                    }
                }
            }
            this.sousFamille = this.familles[0].sousFamilles;

            if (this.sousFamille.length > 0 && this.sousFamille[0].Code != undefined) {
                this.selectedCodeSousFamille = this.sousFamille[0].Code;
            }
        });
    }

    getSizeEchelle(): any {
        const listeContainer: any = this.$refs.listeSalarieBodyCard;
        if (listeContainer != undefined && listeContainer.clientHeight != undefined) {
            const hauteurEchelle = Number(listeContainer.clientHeight) - 70;

            return {
                height: hauteurEchelle + "px"
            };
        } else {
            return {};
        }
    }

    fetchData() {
        this.dataReady = false;

        ServicesFactoryInstance.VariablesService.getContratVariables(async (data) => {
            this.contrats = data;
            this.contratsBase = this.copy(data) as ContratElementVariableDto[];
            this.contratsFiltred = this.contrats;
            await this.doFilter();
            this.dataReady = true;
        });
    }

    /**
     * Evite les recalculs inutiles du filtre lors de la saisie de texte dans le champ de recherche des salariés.
     * @param delay Le délai en millisecondes avant de recalculer le filtre.
     * @returns void
     */
    @Debounce(250)
    private doFilterDebounced(): void {
        this.doFilter();
    }

    doFilter() {
        if (this.filterName != undefined && this.filterName != "") {
            this.contratsFiltred = this.contrats.filter(s => s.FullName != undefined &&
                (s.FullName.toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0 ||
                    (s.NumeroSalarie.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0 ||
                        (s.NumeroContrat.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0))));
        } else {
            this.contratsFiltred = this.contrats;
        }

        this.doOrder();
    }

    oderBy(columnName) {
        if (this.curentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.curentOrderColumn = columnName;
        this.doOrder();
    }

    doOrder() {
        const orderingDesc = this.orderingDesc;
        const columnName = this.curentOrderColumn;
        if (this.contrats != undefined) {
            this.contrats = this.contrats.sort(function (a, b) {
                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    openMessageContrat(numeroContrat, idContrat, nomSalarie, typeMessage, isUserPst = false) {
        if (this.modalMessage == undefined) {
            this.modalMessage = this.$refs.modalMessage as ModalMessage;
        }

        let isDisabled = false;
        if (isUserPst) {
            isDisabled = this.checkEtatSaisie(EtatSaisie.SaisieCloturee);
        }

        this.modalMessage.Init(numeroContrat, nomSalarie, typeMessage, idContrat, isDisabled);
        $("#modalMessage").modal("show");
    }

    openSalarie(idSalarie, titre) {
        EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titre } });
    }

    getClassOfOrder(columnName, desc): string {
        if (columnName == this.curentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    randomColor(color): string {
        const r = () => Math.floor(256 * Math.random());

        return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
    }

    calculerBulletin(contrat: ContratElementVariableDto) {
        if (!this.dataReady) {
            return;
        }
        this.dataReady = false;

        this.changeValiderSaisieState(true);

        if (ParametresInstance.societeCourante == undefined) {
            NotificationServiceInstance.SendFailed("Vous n'avez pas sélectionné de société.");
            this.changeValiderSaisieState(false);
            this.dataReady = true;
        } else if (ParametresInstance.societeCourante.PeriodeActive == undefined) {
            NotificationServiceInstance.SendFailed("Vous n'avez pas de période active.");
            this.changeValiderSaisieState(false);
            this.dataReady = true;
        } else {
            const idContrats: number[] = [];
            idContrats.push(contrat.Id);
            const arretSurImage: DemandeCalculPaieDto = { IdSociete: ParametresInstance.societeCourante.Id, IdContrats: idContrats };
            ServicesFactoryInstance.CalculPaieService.calculerPayes(arretSurImage, (response) => {
                if (response.WarningMessage?.length > 0) {
                    const message = `Au moins un salaire brut est négatif. <br> ${response.WarningMessage.join("<br>")} <br> Merci de vérifier que cela n'est pas dû à une erreur.`;

                    const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
                        {
                            message: message,
                            callBackYes: (): void => {
                                this.actionsFinCalculeBulletin(contrat);
                            },
                            canClose: false,
                            showDialog: true,
                            title: "Attention"
                        });
                    EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
                } else {
                    this.actionsFinCalculeBulletin(contrat);
                }
            }, () => {
                this.changeValiderSaisieState(false);
                this.dataReady = true;
            });
        }
    }

    private actionsFinCalculeBulletin(contrat: ContratElementVariableDto): void {
        // Vérifie si un bulletin de fin de contrat existe pour le contrat passé en paramètre sur le mois en cours.
        ServicesFactoryInstance.CalculPaieService.existeBulletinFinDeContratSurMoisEnCours(contrat.Id, existeFinDeContrat => {
            // Actualise le marquage Fin de contrat si nécéssaire après calcul du bulletin.
            contrat.EstFinContratSurExerciceEnCours = existeFinDeContrat;
        });

        if (this.modalCalculBulletin == undefined) {
            this.modalCalculBulletin = this.$refs.modalCalculBulletin as ModalCalculBulletin;
        }

        if (this.modalCalculBulletin) {
            this.modalCalculBulletin.getBuletin(contrat.Id);
            this.changeValiderSaisieState(false);
            this.dataReady = true;
            $("#modalCalculBulletin").modal("show");
        } else {
            this.changeValiderSaisieState(false);
            this.dataReady = true;
        }
    }

    containVariable(contrat: ContratElementVariableDto): boolean {
        return contrat.ElementVariables.length > 0;
    }

    viewDetails(contrat: ContratElementVariableDto) {
        if (this.modalRecapVariables == undefined) {
            this.modalRecapVariables = this.$refs.modalRecapVariables as ModalRecapVariables;
        }

        if (this.modalRecapVariables == undefined) {
            return;
        }

        this.modalRecapVariables.getDetails(contrat);

        $("#modalRecapVariables").modal("show");
    }

    viewAllDetails() {
        if (this.modalRecapAllVariables == undefined) {
            this.modalRecapAllVariables = this.$refs.modalRecapAllVariables as ModalRecapAllVariables;
        }

        if (this.modalRecapAllVariables == undefined) {
            return;
        }
        this.modalRecapAllVariables.getDetails(this.contratsFiltred);

        $("#modalRecapAllVariables").modal("show");
    }

    getMontant(codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto): string {
        const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
        if (variable.length > 0) {
            const varia = variable[0];
            const montantLibelle = varia.Montant != undefined ? varia.Montant.toString() : "";

            return montantLibelle;
        }

        return "";
    }

    getPeriode(codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto): string {
        const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
        if (variable.length > 0) {
            const varia = variable[0];
            if (varia.Montant != undefined && varia.DateDebut != undefined) {
                let libellePeriode = moment.utc(varia.DateDebut).format("MMM YY");
                if (varia.DateFin != undefined) {
                    libellePeriode += " > " + moment.utc(varia.DateFin).format("MMM YY");
                }

                return libellePeriode;
            }
        }

        return "";
    }

    openPeriodeSettings(idRubrique: number, codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto) {
        if (this.modalAjoutPeriodeVariable == undefined) {
            this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
        }
        const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
        if (variable.length == 0) {
            return;
        }

        this.modalAjoutPeriodeVariable.setElementVariable(false, idRubrique, contrat.Id, variable[0].CodeRubrique, variable[0].CodeNature, undefined, variable[0].DateDebut, variable[0].DateFin, variable[0].Montant);

        $("#modalAjoutPeriodeVariable").modal("show");
    }

    checkSelected() {
        this.displayButton = this.contratsFiltred.filter(c => (c as any).selected == true).length > 0;
    }

    validatePeriode(param: AjoutPeriodeVariableParam): void {
        const selected = param.selected;

        if (selected) {
            this.validateAjoutAll(param);
            this.allSelected = false;
        } else {
            const contrat = this.contrats.filter(c => c.Id == param.idContrat)[0];
            const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == param.codeRubrique && e.CodeNature == param.codeNature);
            if (variable.length == 0) {
                return;
            }

            variable[0].DateDebut = param.dateDebut;
            variable[0].DateFin = param.dateFin;
        }

        this.isModified = true;
        this.displayButton = false;
        this.$forceUpdate();
    }

    enregistrer() {
        this.dataReady = false;

        //Initialisation du tableau des contrats à sauvegarder en se basant sur l'état actuel du formulaire
        let contratsToSave: ContratElementVariableDto[] = this.copy(this.contrats) as ContratElementVariableDto[];
        contratsToSave.forEach((contrat) => {
            contrat.Photo = undefined;
        });

        //Ajout des variables supprimées
        contratsToSave.forEach((contratToSave) => {
            const contratBase = this.contratsBase.filter(c => c.Id == contratToSave.Id)[0];
            contratBase.ElementVariables.forEach((variableBase) => {
                const variableToSave = contratToSave.ElementVariables.filter(v => v.CodeRubrique == variableBase.CodeRubrique
                    && v.CodeNature == variableBase.CodeNature
                    && v.CodeTypeElementVariable == variableBase.CodeTypeElementVariable)[0];
                //Si on ne retrouve pas la variable => elle a été supprimée
                if (!variableToSave) {
                    let variableBaseUpdated = this.copy(variableBase);
                    //Mettre le montant à null pour que le backend supprime la variable
                    variableBaseUpdated.Montant = undefined;
                    contratToSave.ElementVariables.push(variableBaseUpdated);
                    //Si on retrouve la variable et qu'il n'y a pas de modification => elle n'a pas été modifié
                } else if (variableToSave.Montant == variableBase.Montant
                    && this.comparerDates(variableToSave.DateDebut, variableBase.DateDebut)
                    && this.comparerDates(variableToSave.DateFin, variableBase.DateFin)) {
                    const indexVaria = contratToSave.ElementVariables.indexOf(variableToSave, 0);

                    if (indexVaria !== -1) {
                        contratToSave.ElementVariables.splice(indexVaria, 1);
                    }
                }
            });
        });

        //Suppresions des contrats où aucune variable n'est renseignée
        contratsToSave = contratsToSave.filter(c => c.ElementVariables.length > 0);

        ServicesFactoryInstance.VariablesService.updateContratVariables(contratsToSave, (id) => {
            this.annuler();
            NotificationServiceInstance.SendSuccess("L'enregistrement des variables s'est correctement déroulé !");
        }, (e) => {
            this.isModified = false;
            this.dataReady = true;
        });
    }

    annuler() {
        this.isModified = false;
        this.fetchData();
    }

    onDataChanged(idRubrique: number, codeRubrique: string, libelle: string, codeNature: string, codeVariable: string, contrat: ContratElementVariableDto, e: any) {
        if (e.target.value != "" && isNaN(e.target.value)) {
            e.target.value = this.getMontant(codeRubrique, codeNature, contrat);
        } else {
            const variableContrat = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);

            if (variableContrat.length == 0) {
                const newValue: ElementVariableDto = {
                    Id: 0,
                    IdRubrique: idRubrique,
                    CodeRubrique: codeRubrique,
                    LibelleRubrique: libelle,
                    CodeNature: codeNature,
                    CodeTypeElementVariable: "VARIA",
                    CodeVariable: codeVariable,
                    EstSoumise: true,
                    EstValidee: true
                };
                if (e.target.value != "" && !isNaN(Number(e.target.value))) {
                    newValue.Montant = Number(e.target.value);
                    contrat.ElementVariables.push(newValue);
                }
            } else {
                const varia = variableContrat[0];

                if (e.target.value != "" && !isNaN(Number(e.target.value))) {
                    varia.Montant = Number(e.target.value);
                } else {
                    const indexVaria = contrat.ElementVariables.indexOf(varia, 0);

                    if (indexVaria !== -1) {
                        contrat.ElementVariables.splice(indexVaria, 1);
                    }
                }
            }
            this.isModified = true;
        }
    }

    public isSaisieVariableDisabled(ligne: ContratElementVariableDto): boolean {
        if (!this.canEditVariables || !this.dataReady) {
            return true;
        }

        return this.isUtilisateurPst && ligne.EstFinContratSurExerciceEnCours;
    }

    public setClassContratSurExerciceEnCours(contrat: ContratElementVariableDto): string {
        if (contrat.EstFinContratSurExerciceEnCours) {
            return "fin-contrat";
        }

        if (contrat.EstDebutContratSurExerciceEnCours) {
            return "debut-contrat";
        }

        return "";
    }

    public setTitleName(contrat: ContratElementVariableDto): string | undefined {
        if (contrat.EstFinContratSurExerciceEnCours) {
            return `${contrat.FullName} (Sortie dans le mois)`;
        }

        if (contrat.EstDebutContratSurExerciceEnCours) {
            return `${contrat.FullName} (Entrée dans le mois)`;
        }

        return contrat.FullName;
    }

    private openImportCsv(): void {
        if (this.isModified) {
            NotificationServiceInstance.SendWarning("Vous ne pouvez pas effectuer un import CSV tant que vous avez des modifications en cours");

            return;
        }

        if (this.modalImportCsv == undefined) {
            this.modalImportCsv = this.$refs.modalImportCsv as ModalImportCsv;
        }

        this.modalImportCsv.init();
        $("#modalImportCsv").modal("show");
    }

    private validateImport(): void {
        this.fetchData();
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // VIRTUALISATION DU TABLEAU
    // ═══════════════════════════════════════════════════════════════════════════
    //
    //   Seuls les éléments visibles dans le viewport (+ un buffer de chaque côté)
    //   sont rendus. 
    //
    // Cycle de vie :
    //   1. mounted / activated / dataReady=true → initialiserVirtualisation()
    //      Mesure les dimensions réelles des cellules, attache le listener scroll.
    //   2. Événement scroll → surScroll() → recalculerPlageVisible()
    //      Calcule les nouveaux indices début/fin pour chaque axe.
    //   3. Les getters computed (rubriquesVisibles, contratsVisibles, *SpacerAvant,
    //      *SpacerApres) reflètent ces indices. Le template les consomme.
    //
    // ═══════════════════════════════════════════════════════════════════════════

    /** Nombre de rubriques affichées à l'initialisation (avant la première mesure du viewport) */
    private readonly VIRT_RUBRIQUES_INITIALES = 15;
    /** Nombre de contrats affichés à l'initialisation */
    private readonly VIRT_CONTRATS_INITIAUX = 20;
    /** Éléments supplémentaires rendus de chaque côté du viewport */
    private readonly BUFFER_VIRTUALISATION = 6;

    /** Largeur fixe d'une colonne rubrique en mode vertical (px) */
    private readonly LARGEUR_COLONNE_RUBRIQUE = 200;
    /** Hauteur fixe d'une ligne rubrique en mode horizontal (px) */
    private readonly HAUTEUR_LIGNE_RUBRIQUE = 50;

    private largeurColonneFixe = 505;
    private hauteurEntete = 70;
    private hauteurLigneContrat = 60;
    private largeurColonneContrat = 200;

    // Ces indices déterminent quels éléments sont rendus dans le DOM.
    // Ils sont recalculés à chaque scroll via recalculerPlageVisible().
    rubriqueVisibleDebut = 0;
    rubriqueVisibleFin = 15;
    contratVisibleDebut = 0;
    contratVisibleFin = 20;

    /** Request Animation Frame, permet d'empêcher que le calcul au scroll ne se lance plusieurs fois par frame */
    private _rafPending = false;

    /** Rubriques actuellement visibles dans le viewport */
    get rubriquesVisibles(): ParametreDto[] {
        return this.listeRubriqueFiltred.slice(this.rubriqueVisibleDebut, this.rubriqueVisibleFin);
    }

    /** Contrats actuellement visibles dans le viewport */
    get contratsVisibles(): ContratElementVariableDto[] {
        return this.contratsFiltred.slice(this.contratVisibleDebut, this.contratVisibleFin);
    }

    // ─── Computed : tailles des spacers (px) ─────────────────────────────────

    /** Espace avant les rubriques visibles */
    get rubriqueSpacerAvant(): number {
        const tailleCellule = this.modeSalarieHaut ? this.LARGEUR_COLONNE_RUBRIQUE : this.HAUTEUR_LIGNE_RUBRIQUE;

        return this.rubriqueVisibleDebut * tailleCellule;
    }

    /** Espace après les rubriques visibles */
    get rubriqueSpacerApres(): number {
        const tailleCellule = this.modeSalarieHaut ? this.LARGEUR_COLONNE_RUBRIQUE : this.HAUTEUR_LIGNE_RUBRIQUE;

        return Math.max(0, (this.listeRubriqueFiltred.length - this.rubriqueVisibleFin) * tailleCellule);
    }

    /** Espace avant les contrats visibles */
    get contratSpacerAvant(): number {
        const tailleCellule = this.modeSalarieHaut ? this.hauteurLigneContrat : this.largeurColonneContrat;

        return this.contratVisibleDebut * tailleCellule;
    }

    /** Espace après les contrats visibles */
    get contratSpacerApres(): number {
        const tailleCellule = this.modeSalarieHaut ? this.hauteurLigneContrat : this.largeurColonneContrat;

        return Math.max(0, (this.contratsFiltred.length - this.contratVisibleFin) * tailleCellule);
    }

    // ─── Hooks du cycle de vie ───────────────────────────────────────────────

    /**
     * <keep-alive> empêche mounted() d'être rappelé au retour sur la page.
     * activated() se déclenche à chaque réactivation et ré-initialise la
     * virtualisation SANS remettre les plages à zéro, pour conserver la position de scroll de l'utilisateur.
     */
    activated() {
        const data = NavigationData.consume("/saisieDesVariables");

        if (data?.filtre) {
            this.filterName = data.filtre as string;

            if (this.dataReady) {
                this.doFilter();
            }
        }

        this.$nextTick(() => this.initialiserVirtualisation());
    }

    /**
     * On détache le listener scroll pour ne pas réagir au scroll d'un
     * tableau invisible. activated() le ré-attachera au retour.
     */
    deactivated() {
        this.detacherScrollListener();
    }

    beforeDestroy() {
        this.detacherScrollListener();
    }

    /** Détache l'écouteur de scroll du tableau */
    private detacherScrollListener(): void {
        const table = this.getTableElement();
        if (table) {
            table.removeEventListener("scroll", this.surScroll);
        }
    }

    // ─── Méthodes privées ────────────────────────────────────────────────────────────

    /** Remet toutes les plages visibles à leurs valeurs initiales */
    private reinitialiserPlagesVisibles(): void {
        this.rubriqueVisibleDebut = 0;
        this.rubriqueVisibleFin = this.VIRT_RUBRIQUES_INITIALES;
        this.contratVisibleDebut = 0;
        this.contratVisibleFin = this.VIRT_CONTRATS_INITIAUX;
    }

    /**
     * Retourne l'élément <table> actuellement affiché.
     */
    private getTableElement(): HTMLElement | null {
        return this.$refs.scrollTable as HTMLElement | null;
    }

    /**
     * Point d'entrée de la virtualisation.
     * 1. Mesure les dimensions réelles du tableau
     * 2. Attache l'écouteur de scroll
     * 3. Effectue un premier calcul de la plage visible
     */
    private initialiserVirtualisation(): void {
        const table = this.getTableElement();
        if (!table) {
            return;
        }

        // Retire un précédent listener éventuel
        table.removeEventListener("scroll", this.surScroll);

        this.mesurerDimensionsTableau(table);
        table.addEventListener("scroll", this.surScroll, { passive: true });
        this.recalculerPlageVisible();
    }

    /**
     * Mesure les dimensions réelles des cellules du tableau à partir du DOM.
     */
    private mesurerDimensionsTableau(table: HTMLElement): void {
        // Largeur de la colonne sticky à soustraire de la zone scrollable
        const colonneFixe = table.querySelector("thead .head-sticky-th") as HTMLElement;
        if (colonneFixe) {
            this.largeurColonneFixe = colonneFixe.offsetWidth;
        }

        // Hauteur du header à soustraire de la zone scrollable verticale
        const entete = table.querySelector("thead") as HTMLElement;
        if (entete) {
            this.hauteurEntete = entete.offsetHeight;
        }

        // Taille d'un élément contrat (hauteur d'une ligne ou largeur d'une colonne selon le mode)
        if (this.modeSalarieHaut) {
            const premiereLigne = table.querySelector("tbody tr .body-sticky-th")?.closest("tr") as HTMLElement;
            if (premiereLigne) {
                this.hauteurLigneContrat = premiereLigne.offsetHeight || 60;
            }
        } else {
            const premiereColonne = table.querySelector("thead .head-no-sticky-th") as HTMLElement;
            if (premiereColonne) {
                this.largeurColonneContrat = premiereColonne.offsetWidth || 200;
            }
        }
    }


    /**
     * Callback du scroll qui recalcule les éléments à afficher
     */
    private surScroll = (): void => {
        // Si un calcul est déjà prévu pour cette frame, on ignore
        if (this._rafPending) return;  

        this._rafPending = true;
        requestAnimationFrame(() => {
            this._rafPending = false;
            // Exécuté une seule fois par frame, quelle que soit la fréquence des events
            this.recalculerPlageVisible();  
        });
    };

    /**
     * Calcule les indices de début/fin des rubriques et contrats visibles
     * en fonction de la position de scroll et des dimensions du viewport.
     */
    private recalculerPlageVisible(): void {
        const table = this.getTableElement();
        if (!table || (table.clientWidth === 0 && table.clientHeight === 0)) {
            return;
        }

        // Dimensions de la zone scrollable (viewport total − éléments fixes)
        const largeurScrollable = table.clientWidth - this.largeurColonneFixe;
        const hauteurScrollable = table.clientHeight - this.hauteurEntete;

        // Calcul de la plage visible pour les rubriques
        const [rubriqueDebut, rubriqueFin] = this.modeSalarieHaut
            // Mode vertical : rubriques = colonnes → dépend du scroll horizontal
            ? this.calculerPlage(table.scrollLeft, largeurScrollable, this.LARGEUR_COLONNE_RUBRIQUE, this.listeRubriqueFiltred.length)
            // Mode horizontal : rubriques = lignes → dépend du scroll vertical
            : this.calculerPlage(table.scrollTop, hauteurScrollable, this.HAUTEUR_LIGNE_RUBRIQUE, this.listeRubriqueFiltred.length);

        // Calcul de la plage visible pour les contrats
        const [contratDebut, contratFin] = this.modeSalarieHaut
            // Mode vertical : contrats = lignes → dépend du scroll vertical
            ? this.calculerPlage(table.scrollTop, hauteurScrollable, this.hauteurLigneContrat, this.contratsFiltred.length)
            // Mode horizontal : contrats = colonnes → dépend du scroll horizontal
            : this.calculerPlage(table.scrollLeft, largeurScrollable, this.largeurColonneContrat, this.contratsFiltred.length);

        // Mise à jour uniquement si changement (évite des déclenchements de réactivité Vue inutiles)
        if (rubriqueDebut !== this.rubriqueVisibleDebut || rubriqueFin !== this.rubriqueVisibleFin) {
            this.rubriqueVisibleDebut = rubriqueDebut;
            this.rubriqueVisibleFin = rubriqueFin;
        }
        if (contratDebut !== this.contratVisibleDebut || contratFin !== this.contratVisibleFin) {
            this.contratVisibleDebut = contratDebut;
            this.contratVisibleFin = contratFin;
        }
    }

    /**
     * Calcule la plage d'éléments visibles pour un axe donné (rubriques ou contrats).
     * Méthode pure : le résultat ne dépend que des paramètres d'entrée + BUFFER_VIRTUALISATION.
     *
     * @param positionScroll  Position de scroll actuelle sur cet axe (px)
     * @param tailleViewport  Taille visible de la zone scrollable sur cet axe (px)
     * @param tailleElement   Taille fixe d'un élément sur cet axe (px)
     * @param totalElements   Nombre total d'éléments dans la liste source
     * @returns [debut, fin]  Indices de début (inclus) et fin (exclus) du slice à rendre
     */
    private calculerPlage(positionScroll: number, tailleViewport: number, tailleElement: number, totalElements: number): [number, number] {
        // Premier et dernier éléments visibles (sans buffer)
        const premierVisible = Math.floor(positionScroll / tailleElement);
        const dernierVisible = Math.ceil((positionScroll + tailleViewport) / tailleElement);

        // Ajout du buffer de chaque côté, borné entre 0 et le total
        const debut = Math.max(0, premierVisible - this.BUFFER_VIRTUALISATION);
        const fin = Math.min(totalElements, dernierVisible + this.BUFFER_VIRTUALISATION);

        // Garantit que fin >= debut (sécurité si totalElements = 0 ou viewport = 0)
        return [debut, Math.max(debut, fin)];
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // FIN VIRTUALISATION
    // ═══════════════════════════════════════════════════════════════════════════

    /**
     * Permet de changer l'état du bouton "Valider la saisie" dans le bandeau
     * @param disable
     */
    private changeValiderSaisieState(disable: boolean): void {
        EventBus.$emit(EventConstants.CHANGE_VALIDER_SAISIE_STATE, disable);
    }

    /**
     * Permet de faire une copie d'un élément
     * @param data
     * @returns
     */
    private copy(data): any {
        const copied = JSON.parse(JSON.stringify(data));
        return copied;
    }

    /**
     * Permet de comparer 2 dates
     * @param date1
     * @param date2
     * @returns
     */
    private comparerDates(date1: any, date2: any): boolean {
        // Si les deux valeurs sont undefined, retourner vrai
        if (date1 === undefined && date2 === undefined) {
            return true;
        }

        // Si l'une des deux valeurs est undefined, retourner faux
        if (date1 === undefined || date2 === undefined) {
            return false;
        }
        //On convertit les dates en moment pour ne pas avoir de problème de timezone
        const moment1 = moment.utc(date1);
        const moment2 = moment.utc(date2);

        // Comparer les deux valeurs
        return new Date(moment1.year(), moment1.month(), moment1.date()).toDateString() === new Date(moment2.year(), moment2.month(), moment2.date()).toDateString();
    }
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/saisieDesVariables.ts